// extracted by mini-css-extract-plugin
export default {"buttonBlock":"AnnouncementButtons_buttonBlock__9r0if","cartButton":"AnnouncementButtons_cartButton__8ionR","orderButton":"AnnouncementButtons_orderButton__3brsR"};